import { createComponent } from '@front/utils/alpine';
const Toggler = createComponent((opts) => ({
    keyboard: opts.keyboard ?? false,
    props: opts.props ?? {},
    state: opts.state ?? false,
    get isOpen() {
        return this.state;
    },
    get isClosed() {
        return !this.state;
    },
    open(emit) {
        this.toggle(true, emit);
    },
    close(emit) {
        this.toggle(false, emit);
    },
    toggle(force, emit) {
        this.state = force !== undefined ? force : !this.state;
        if (emit) {
            this.$dispatch(this.state ? 'open' : 'close');
        }
    },
    toggleFn(cb, force, emit) {
        this.toggle(force, emit);
        cb.bind(this)(this);
    },
    destroy() {
        this.$el.removeEventListener('keyup', this.handleKeyboardEvent);
        this.$nextTick(() => {
            document.body.focus();
        });
    },
    handleKeyboardEvent(event) {
        if (event.key == 'Escape') {
            this.close();
        }
    },
    init() {
        Object.assign(this, this.props);
        if (this.keyboard) {
            this.$el.addEventListener('keyup', this.handleKeyboardEvent.bind(this));
        }
    },
}));
export { Toggler };
